export enum ProfileAdvancedSearchCertificationFieldEnum {
  CertificationDate,
  RenewalDate,
  ExpirationDate,
  CeuDateEarned,
}
